module.exports = __webpack_public_path__ + "img/award_star.b1291c01.svg";